export default __webpack_public_path__ + "static/media/5star.332988d7.png";